import { useSetAtom } from "jotai";
import type { FunctionComponent } from "react";

import { registerEmailCookieAtom } from "shared/lib/account";

import { CloseButton, Container, Email, Message, StyledCloseIcon } from "./styles";

export type Props = {
  className?: string;
  email: string;
};

export const HomeAccountActivation: FunctionComponent<Props> = ({ className, email }) => {
  const updateRegisterEmailCookie = useSetAtom(registerEmailCookieAtom);

  const handleCloseButtonClick = () => {
    updateRegisterEmailCookie(null);
  };

  return (
    <Container className={className}>
      <Message>
        We sent an activation email to you at <Email>{email}</Email>. Please check your email box.
      </Message>
      <CloseButton onClick={handleCloseButtonClick}>
        <StyledCloseIcon />
      </CloseButton>
    </Container>
  );
};

HomeAccountActivation.displayName = "HomeAccountActivation";
